import React from "react";

import "./Header.scss";

const Header = () => {
  console.log("Hello, World!");
  return(
    <header className="header">
      <h1>Styles Guide</h1>
      <p>Find the best colors and fonts for your project.</p>
    </header>
  );
};

export default Header;